import React from "react";
import LegalPageLayout from "./LegalPageLayout";

export default function BuddyAvanzaAINotice() {
  return (
    <LegalPageLayout
      documentKey="ai_notice"
      testid="legal-ai-notice"
      eyebrow="Transparencia"
      documentTitle="Inteligencia Artificial en BUDDY AVANZA"
      intro="BUDDY AVANZA utiliza inteligencia artificial en determinadas funciones de acompañamiento educativo. Este aviso explica de forma clara qué hace, qué no hace y cómo se aplican controles de seguridad."
    >
      {({ contactEmail }) => (<>
        <section>
          <h2>1. Uso de inteligencia artificial</h2>
          <p>BUDDY AVANZA utiliza inteligencia artificial en determinadas
             funciones de acompañamiento educativo, como el módulo Buddy
             Tutor y componentes de reflexión pedagógica.</p>
        </section>

        <section>
          <h2>2. Qué puede hacer Buddy</h2>
          <ul>
            <li>Generar preguntas orientadoras para ayudar al estudiante a razonar.</li>
            <li>Ofrecer pistas graduadas para avanzar en un problema.</li>
            <li>Proporcionar explicaciones adaptadas al contexto pedagógico.</li>
            <li>Acompañar el razonamiento paso a paso cuando está disponible.</li>
            <li>Ayudar a comprender errores y a reflexionar sobre ellos.</li>
          </ul>
        </section>

        <section>
          <h2>3. Consideraciones importantes</h2>
          <ul>
            <li>La inteligencia artificial <strong>puede equivocarse</strong>.</li>
            <li>Buddy <strong>no sustituye al docente</strong> ni al criterio profesional educativo.</li>
            <li>Las respuestas de Buddy no constituyen una fuente infalible de información.</li>
            <li>Se aplican controles internos de seguridad y contenido.</li>
            <li>Durante determinadas evaluaciones y simulaciones, la asistencia de Buddy se restringe intencionalmente para preservar la finalidad diagnóstica de la actividad.</li>
            <li>La plataforma utiliza mecanismos de gobernanza técnica para controlar el uso de estas funciones.</li>
          </ul>
        </section>

        <section>
          <h2>4. Datos y aprendizaje del estudiante</h2>
          <p>BUDDY AVANZA persiste únicamente señales agregadas del
             comportamiento educativo del estudiante (por ejemplo, si
             interactuó, avanzó o solicitó una pista). El contenido literal
             de las conversaciones con Buddy y las respuestas completas del
             modelo generativo no se almacenan como transcripción.</p>
          <p>La información enviada al componente generativo se limita al
             contexto pedagógico mínimo necesario para producir el
             acompañamiento educativo.</p>
        </section>

        <section>
          <h2>5. Recomendaciones para familias y estudiantes</h2>
          <ul>
            <li>Utilizar a Buddy como acompañamiento, no como reemplazo del estudio.</li>
            <li>Verificar información importante con fuentes de confianza.</li>
            <li>Reportar cualquier respuesta que se considere inapropiada.</li>
          </ul>
        </section>

        <section>
          <h2>6. Contacto</h2>
          <p>Para consultas o reportes relacionados con el uso de
             inteligencia artificial en BUDDY AVANZA, puedes escribir a{" "}
             <a href={`mailto:${contactEmail}`} data-testid="ai-notice-contact-email">{contactEmail}</a>.</p>
        </section>

        <section>
          <h2>7. Proveedores externos y procesamiento internacional</h2>
          <p>BUDDY AVANZA utiliza modelos de inteligencia artificial
             operados por proveedores externos especializados (por ejemplo,
             OpenAI). El procesamiento de las solicitudes al modelo puede
             realizarse fuera de El Salvador (por ejemplo, en Estados
             Unidos), conforme a la ubicación de infraestructura del
             proveedor. La información enviada al proveedor se limita al
             <strong> contexto pedagógico pseudonimizado</strong> necesario
             para producir el acompañamiento educativo. Para más detalle
             sobre proveedores y transferencia internacional, consulta las
             secciones 11 y 12 de la Política de Privacidad.</p>
        </section>

        <section>
          <h2>8. Información que Buddy NO envía al proveedor de IA</h2>
          <p>De acuerdo con el diseño actual del servicio, la información
             que BUDDY AVANZA <strong>no envía</strong> al proveedor
             externo de inteligencia artificial incluye:</p>
          <ul>
            <li>Nombre del estudiante.</li>
            <li>Correo electrónico del estudiante.</li>
            <li>Fecha de nacimiento del estudiante.</li>
            <li>Datos del padre, madre, tutor legal o adulto responsable.</li>
            <li>Datos financieros o credenciales de pago.</li>
            <li>Transcripciones completas de las conversaciones con Buddy.</li>
          </ul>
          <p>En su lugar se transmite un identificador interno pseudónimo y
             el contexto pedagógico mínimo suficiente para generar el
             acompañamiento educativo.</p>
        </section>
      </>)}
    </LegalPageLayout>
  );
}
